import createEditSimProviderRedux from 'Modules/simProviders/views/.components/createEditSimProvider/redux/reducer';
import deleteSimProviderRedux from 'Modules/simProviders/views/.components/deleteSimProvider/redux/reducer';

//export redux objects
export default {
	createEditSimProviderRedux,
	deleteSimProviderRedux
};